




































































import debounce from 'lodash/debounce';

import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';
import { validationMixin } from 'vuelidate'
import { required, requiredIf, minLength, sameAs } from 'vuelidate/lib/validators'

import { getFieldError } from '@/core/tools/forms/get_field_error';

import { STORE_KEY as PARENT_STORE_KEY } from '../_store';
import { STORE_KEY, store } from './_store';
import Attachments from '@/components/Controls/Attachments.vue';

@Component({
  mixins: [ validationMixin ],
  computed: {
    ...mapState(STORE_KEY, [
        'loaded', 'loading', 'fatalError',
        'rows'
    ]),
    ...mapGetters(STORE_KEY, [
        'no_allow'
    ])
  },
  methods: {
    getFieldError,
    ...mapActions(STORE_KEY, [
        'setValue'
    ])
  },
  validations() {
    const rules: any = {
    }

    return {
      form: rules
    }
  },
  components: {
    Attachments
  }
})
export default class ShiftAddWashForm extends Vue {
  @Prop({ type: Array }) equipments!: any[];
  @Prop({ type: Object }) initParams!: any[];
  @Prop({ type: String }) typeLine!: any[];

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  public mounted() {
    this.$store.dispatch(`${STORE_KEY}/init`, {
      equipments: this.equipments,
      typeLine: this.typeLine,
      initParams: this.initParams
    });
  }

  saveFormData() {
    this.$store.dispatch(`${STORE_KEY}/saveForm`, )
    .then((result) => {
      this.$buefy.snackbar.open(`Данные успешно сохранены`);
      this.$v.form.$reset();

      this.$emit('form-close', result);
      (this.$parent as any).close();
    })
    .catch(() => {
      this.$buefy.snackbar.open({
        type: 'is-warning',
        message: `При сохранении возникли проблемы. Попробуйте позже.`
      })
    })
  }

  beforeDestroy() {
    this.$store.dispatch(`${STORE_KEY}/reset`);
  }
}

